import CardTable from "components/CardTable/CardTable";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { tanksSelector } from "./selector";
import { columns } from "./columns";
import { TableInputs } from "components/CardTable/TableInputs";
import { setTanksInputs, getTanks } from "redux/actions/tanks/tanksAction";
import AddIcon from "@material-ui/icons/Add";
import { ModalV2 } from "components/Modal/ModalV2";
import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";
import { TankForm } from "./TankForm";
import RegularButton from "components/CustomButtons/Button";
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import CachedIcon from '@mui/icons-material/Cached';

export const TanksPage_ = () => {
    const tableKey = "tanks";
    const loadings = ["loadingTanks", "loadingModTank"];
    const tanks = useSelector(tanksSelector);
    const { station, company } = useSelector(({ tanks2 }) => tanks2);
    const { buildCompLoadings, buildTableConfig } = useSearch();
    const { isLoadingComp, configTables } = useSelector(({ search }) => search);
    const [filterTanks, setFilterTanks] = useState(tanks)
    const [open, handleOpen] = useToggle();
    const dispatch = useDispatch()

    const handleRefresh = () => {
        dispatch(getTanks())
    }

    useEffect(() => {
        buildCompLoadings(loadings);
        !configTables[tableKey] && buildTableConfig(tableKey);
    }, []);

    useEffect(() => {
        station?.length > 0
            ? setFilterTanks(
                station.map(val => {
                    return Object.keys(tanks)?.map(id => tanks[id]).filter(tank => tank.idStation === val.id)
                }).flat()
            )
            : company?.stations ?
                setFilterTanks(
                    company.stations.map(val => {
                        return Object.keys(tanks)?.map(id => tanks[id]).filter(tank => tank.idStation === val.id)
                    }).flat()
                )
                : setFilterTanks(tanks)
    }, [company, station, tanks]);

    return (
        <>
            <CardTable
                hasHeader
                icon={<PropaneTankIcon />}
                blockBtn
                title="Tanques"
                isLoading={isLoadingComp?.loadingTanks}
                columns={columns}
                data={filterTanks}
                tableContent={
                    <TableInputs
                        reducer="tanks2"
                        companies
                        multiStations
                        dispatchAction={setTanksInputs}
                        blockBtn
                        submitButtonShow={false}
                    />
                }
                tableKey={tableKey}
                hasControl
                controls={
                    <>
                        <RegularButton round justIcon color="info" onClick={handleRefresh}>
                            <CachedIcon style={{ margin: 0 }} />
                        </RegularButton>
                        <RegularButton round justIcon color="info" onClick={handleOpen}>
                            <AddIcon style={{ margin: 0 }} />
                        </RegularButton>
                    </>
                }
            />
            <ModalV2
                open={open}
                onClose={handleOpen}
                title="Agregar Nuevo Tanque"
                justConfirm
            >
                <TankForm onClose={handleOpen} />
            </ModalV2>
        </>
    );
};